import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Legal from './pages/Legal';
import Privacy from './pages/Privacy';
import CookieConsent from './components/CookieConsent';
import ErrorPage from './components/ErrorPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-black text-white">
      <ScrollToTop />
      <Navigation currentPage={location.pathname.substring(1) || 'home'} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;